import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import '../styles/DashboardSidebar.css';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import AddAdminModal from './AddAdminModal';
import AddProjectModal from './AddProjectModal';
import MessagesModal from './MessagesModal';
import UsersListModal from './UsersListModal';

const DashboardSidebar = ({ refreshProjects }) => {
  const { logout } = useAuth();
  const { translations } = useLanguage();
  const [activeModal, setActiveModal] = useState(null);

  const openModal = (modalName) => {
    setActiveModal(modalName);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const handleAdminAdded = () => {
    // You could add a toast notification here
    console.log('Admin added successfully');
  };

  const handleProjectAdded = () => {
    if (refreshProjects) {
      refreshProjects();
    }
  };

  return (
    <aside className="sidebar">
      <h3>{translations.admin.dashboard}</h3>
      <ul>
        <li onClick={() => openModal('addAdmin')}>{translations.admin.addAdmin}</li>
        <li onClick={() => openModal('messages')}>{translations.admin.messages}</li>
        <li onClick={() => openModal('addProject')}>{translations.admin.addProject}</li>
        <li onClick={() => openModal('usersList')}>{translations.admin.usersList}</li>
      </ul>
      <button className="logout-btn" onClick={logout}>
        {translations.admin.logout}
      </button>

      <AnimatePresence>
        {activeModal === 'addAdmin' && (
          <AddAdminModal onClose={closeModal} onAdminAdded={handleAdminAdded} />
        )}
        {activeModal === 'addProject' && (
          <AddProjectModal onClose={closeModal} onProjectAdded={handleProjectAdded} />
        )}
        {activeModal === 'messages' && <MessagesModal onClose={closeModal} />}
        {activeModal === 'usersList' && <UsersListModal onClose={closeModal} />}
      </AnimatePresence>
    </aside>
  );
};

export default DashboardSidebar;